import {
  CreationSetForShowFragment,
  ProjectDetailsForEditFragment,
  ProjectDetailsForShowFragment,
  ProjectForAllOfOrganizationFragment,
} from '../../generated/graphql';
import { getDemoCreationSet } from './creationSet';

export const demoProjectData: Array<{
  data: {
    project: ProjectDetailsForShowFragment | ProjectDetailsForEditFragment | ProjectForAllOfOrganizationFragment;
  };
}> = [
  {
    data: {
      project: {
        id: 'PJ01FKZ3RCCRJS',
        finalized: false,
        versionId: '22569',
        matchingFormat: 'auto',
        organization: {
          id: '29077',
          name: 'mediba（Ad）_ビジネス戦略Unit Mgr',
          pointBalance: 0,
          features: {
            canOpenOfferWhenDisagreed: false,
          },
          businessRegion: {
            key: 'jp',
            idBusinessRegion: 'japan',
            timeZone: 'Asia/Tokyo',
          },
        },
        originId: 'PJ01FKZ3RCCRJS',
        parentId: null,
        title: '【KaizenAdサンプル】Facebook配信用動画',
        state: 'assigned',
        createdBy: {
          id: '18231',
          name: 'Kaizen CS okamoto',
          profileImageUrl: '',
        },
        designInspirationCase: null,
        projectType: {
          id: '135',
          published: false,
          version: 2,
          title: '動画コンテンツを活用した動画',
          description: 'ドラマ / 番組 / アニメ / 映画などの動画コンテンツを利用した広告動画の制作を行います。',
          thumbnailImageUrl:
            '//assets-ad.kaizenplatform.net/project_types/307/%E5%8B%95%E7%94%BB%E3%82%B3%E3%83%B3%E3%83%86%E3%83%B3%E3%83%84%E3%82%92%E6%B4%BB%E7%94%A8%E3%81%97%E3%81%9F%E5%8B%95%E7%94%BB.png?1557810030',
          sampleVideoUrl:
            '//assets-ad.kaizenplatform.net/project_types/308/%E5%8B%95%E7%94%BB%E3%82%B3%E3%83%B3%E3%83%86%E3%83%B3%E3%83%84%E3%82%92%E6%B4%BB%E7%94%A8%E3%81%97%E3%81%9F%E5%8B%95%E7%94%BB.mp4?1557810030',
          expectedDeliveryPeriod: '3~5営業日',
          outputSpecification:
            '以下の仕様で制作依頼が可能です。\r\n\r\nファイル形式: 動画(mp4形式) \r\nサウンド: 指定可',
          regulation:
            '提供必須なもの\r\n・動画コンテンツ素材（3本程度）\r\n・音声データ（3本程度）\r\n・ロゴデータ\r\n\r\n必要に応じて提供するもの\r\n・各種レギュレーション規定資料\r\n※ ロゴや素材の取扱規定・クリエイティブのトーン＆マナー規定など',
          creativeBriefDefinition: {
            id: '970',
            sections: [
              {
                id: '35405036-0E8F-46AD-A0E7-811F21E694A8',
                label: '案件詳細',
                description: '動画広告を考えている商品について、以下を記載してみましょう！',
                fields: [
                  {
                    key: '59C3B461-A1CC-49BB-8138-CF792978A495',
                    type: 'SINGLE_LINE_TEXT',
                    label: '商品/サービス',
                    placeholder: '例)Kaizen Ad',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: '268711DB-9DCC-4175-A747-BF20848FC50F',
                    type: 'SINGLE_LINE_TEXT',
                    label: '関連URL',
                    placeholder: '例)https://ja.kaizen-ad.com/',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: '9B706205-2082-4D69-9AEA-4A2860FCA7AF',
                    type: 'SINGLE_LINE_TEXT',
                    label: 'ペルソナ',
                    placeholder: '例)動画広告を考えているマーケティング担当者。',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: 'CC477764-DE4F-48EE-94B4-12F5589D3E78',
                    type: 'SINGLE_LINE_TEXT',
                    label: '訴求軸',
                    placeholder: '特に押し出したいポイントをご記載ください',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: '114CDB1A-1AAA-459A-B436-9EF980A68F3A',
                    type: 'SINGLE_LINE_TEXT',
                    label: '広告の目的（KPI）',
                    placeholder: '例)資料ダウンロード・問い合わせ',
                    helperText: '',
                    isRequired: false,
                  },
                ],
              },
              {
                id: '0B5B4218-21A2-256D-D6AF-19626C2D7B23',
                label: '制作仕様',
                description:
                  '最終的に納品されるクリエイティブのフォーマットについて教えてください。プロジェクトタイプによっては固定されています。',
                fields: [
                  {
                    key: 'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA4',
                    type: 'FIXED',
                    label: '形式',
                    value: '動画（mp4）',
                  },
                  {
                    key: '3CC48A2F-96CB-468D-9C08-FC6157B5F8AF',
                    type: 'SELECT_ONE',
                    label: 'サウンド',
                    choices: [
                      {
                        key: '音声なし',
                        label: '音声なし',
                      },
                      {
                        key: '[無償]BGMあり（提供素材あり）',
                        label: '[無償]BGMあり（提供素材あり）',
                      },
                      {
                        key: '[無償]BGMあり（Kaizen Adにお任せ ※納品後のBGM変更は有償修正扱いとなります）',
                        label: '[無償]BGMあり（Kaizen Adにお任せ ※納品後のBGM変更は有償修正扱いとなります）',
                      },
                      {
                        key: '[有償]ナレーション＋BGMあり',
                        label: '[有償]ナレーション＋BGMあり',
                      },
                    ],
                    helperText: '',
                  },
                ],
              },
              {
                id: '8DB5ED50-482E-4BDB-9227-40914C7099A0',
                label: '動画構成',
                description: '動画の構成を指示してください。',
                fields: [
                  {
                    key: '2F0D2C92-A694-42ED-AE58-43EB3629A665',
                    type: 'MULTI_LINE_TEXT',
                    label: '構成',
                    placeholder:
                      '例)以下の内容で制作をお願いします\n構成：問題定義→解決方法→追加説明→オファー\n表現：画面分割の演出を盛り込んでください\nテイスト：スタイリッシュなイメージ\n\n1.（問題提起）\n動画は高い...　動画は遅い...　動画のクオリティーは安定しない...\n2.（解決方法）\nKaizenAdなら1本5万円から、最短5分で発注、5営業日で初稿納品が可能！\n3.（追加説明）\n「累計10,000クリエイティブ制作の実績あり！」「APAC唯一のFacebook/Google社の認定パートナー」だからクオリティも安心。おまけにノウハウも兼ね揃えています！\n上記訴求ポイントを伝えつつ、過去の動画事例を画面分割で表示してください。\n4.（エンドカット）\n豊富な動画事例を掲載した資料DLはこちら',
                    helperText: '',
                    isRequired: false,
                  },
                ],
              },
              {
                id: '1B5B4218-21A2-256D-D6AF-19626C2D7B23',
                label: 'レギュレーション',
                description:
                  'クリエイティブを制作する上で必須なブランド規定や関連法規(薬事法・景品表示法)がある場合は記入してください。こちらで記入された事項についての修正は、無償でクリエイターに依頼できます。',
                fields: [
                  {
                    key: 'E6810179-60AC-4BBD-A716-522CFEEC660F',
                    type: 'MULTI_LINE_TEXT',
                    label: '制作する上でのレギュレーション',
                    placeholder:
                      '例)\n・トンマナ/フォントについてはWebサイトに準ずる\n・ロゴは縦横比変更不可\n・Kaizen Adのロゴを右上に常設してください\n・コピーライト「©︎株式会社Kazien Platform」を表示してください',
                    helperText: '制作する上でクリエイターに必ず守っていただきたいことを記載してください。',
                    isRequired: false,
                  },
                ],
              },
            ],
          },
          assetCategoryDefinition: {
            id: '1110',
            sections: [
              {
                id: '0a3dd0dd-611d-47c8-b38e-aad399fba0f3',
                meta: {
                  helperUrl: 'https://help.kaizen-ad.com/ja/articles/4095148',
                  isRequired: true,
                  allowSearchTypes: [],
                  allowRecommendTypes: [],
                  audioPreparedMaterialIds: [],
                  imagePreparedMaterialIds: [],
                  videoPreparedMaterialIds: [],
                  isAllowLeaveToTheCreators: false,
                },
                label: '',
                description:
                  '■必要素材(最低1つのファイルをアップロードいただくか、URLの入力が必要です。複数選択可能)\n・LP/静止画バナー(ai/psdデータ推奨)\n・画像(png/jpg/bmp推奨)\n・動画(白素材データ+各音声データ推奨)\n・チラシ/パンフレットデータ(aiデータ推奨)\n・資料（パワーポイントなど）\n\n※ 以前制作した動画のリサイズをご発注の場合は下記データが必須素材となります\n・オリジナルの動画(mp4)\n\n※ 【オプション】ナレーションをご発注の場合は、下記データのご準備をお願いいたします\n・ナレーションをつける動画ファイル（mp4）\n・ナレーション原稿（Excel,word,pdfなど）\n・（必要がある場合のみ）BGM音源',
                fields: [
                  {
                    key: '3ef3d9a7-062b-4f96-be6e-61adc7fc1b99',
                    type: 'FILE_IDS',
                    label: 'ファイルを選択',
                  },
                  {
                    key: 'bd1d10a5-0c68-42d2-bf3c-2ceed06e1787',
                    type: 'SINGLE_LINE_TEXT',
                    label: '共有ファイルのURL',
                    placeholder: 'https://',
                    helperText: '共有ファイルのURL',
                    isRequired: false,
                  },
                  {
                    key: '643df670-9be0-4bbf-b709-6c29e7900cea',
                    type: 'MULTI_LINE_TEXT',
                    label: '補足事項',
                    placeholder: '注意事項やパスワードなど',
                    helperText: '補足事項',
                    isRequired: false,
                  },
                  {
                    key: 'e907e43b-f263-4ef1-be99-d1f91524adda',
                    type: 'SELECT_ONE',
                    label: '素材を準備しますか？',
                    choices: [
                      {
                        key: 'leave to the creators',
                        label: 'クリエイターに任せる',
                      },
                      {
                        key: 'make your own choice',
                        label: '自分で選ぶ',
                      },
                    ],
                    helperText: '素材を準備しますか？',
                  },
                ],
              },
            ],
          },
          supportingCreativeFormatNetworks: [
            {
              id: '2',
              key: 'facebook',
              name: 'Facebook',
              placements: [
                {
                  id: '2',
                  key: 'facebook_feeds',
                  name: 'Feeds',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '1',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '2',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '3',
                  key: 'facebook_in_stream',
                  name: 'In-Stream',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '3',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '4',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '3',
              key: 'instagram',
              name: 'Instagram',
              placements: [
                {
                  id: '4',
                  key: 'instagram_feeds',
                  name: 'Feeds',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '5',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '6',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '5',
                  key: 'instagram_stories',
                  name: 'Stories',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '7',
                          availables: [
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '8',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '5',
              key: 'youtube',
              name: 'YouTube',
              placements: [
                {
                  id: '7',
                  key: 'youtube_trueview',
                  name: 'TrueView',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '11',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 840,
                                height: 1260,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '12',
                          availables: [
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '8',
                  key: 'youtube_non_skippable_video_ads',
                  name: 'Non-skippable video ads',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '13',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '14',
                          availables: [
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '9',
                  key: 'youtube_bumper_ads',
                  name: 'Bumper ads',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '15',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 840,
                                height: 1260,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '16',
                          availables: [
                            {
                              seconds: 6,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '6',
              key: 'twitter',
              name: 'Twitter',
              placements: [
                {
                  id: '11',
                  key: 'twitter_promoted_video_in_stream',
                  name: 'Promoted Video / In-Stream',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '18',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '19',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '7',
              key: 'line',
              name: 'LINE',
              placements: [
                {
                  id: '12',
                  key: 'line_any_placement',
                  name: 'Any Placement',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '20',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '21',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '8',
              key: 'yahoo',
              name: 'Yahoo',
              placements: [
                {
                  id: '13',
                  key: 'yahoo_any_placement',
                  name: 'Any Placement',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '22',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 640,
                                height: 360,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 600,
                                height: 600,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '23',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '9',
              key: 'google',
              name: 'Google',
              placements: [
                {
                  id: '15',
                  key: 'google_any_placement',
                  name: 'Any Placement',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '26',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 6,
                                height: 5,
                              },
                              presetSize: {
                                width: 300,
                                height: 250,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '27',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '12',
              key: 'apple',
              name: 'Apple',
              placements: [
                {
                  id: '27',
                  key: 'apple_search_ads',
                  name: 'Search Ads',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '49',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 3,
                              },
                              presetSize: {
                                width: 1600,
                                height: 1200,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 3,
                                height: 4,
                              },
                              presetSize: {
                                width: 1200,
                                height: 1600,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 19,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 886,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 19,
                              },
                              presetSize: {
                                width: 886,
                                height: 1920,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '50',
                          availables: [
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '11',
              key: 'other',
              name: 'other',
              placements: [
                {
                  id: '34',
                  key: 'long_size_option_60',
                  name: 'Long Video (60sec)',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '60',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 600,
                                height: 900,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 6,
                                height: 5,
                              },
                              presetSize: {
                                width: 300,
                                height: 250,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '59',
                          availables: [
                            {
                              seconds: 40,
                            },
                            {
                              seconds: 50,
                            },
                            {
                              seconds: 60,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '35',
                  key: 'long_size_option_90',
                  name: 'Long Video (90sec)',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '62',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 600,
                                height: 900,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 6,
                                height: 5,
                              },
                              presetSize: {
                                width: 300,
                                height: 250,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '61',
                          availables: [
                            {
                              seconds: 70,
                            },
                            {
                              seconds: 80,
                            },
                            {
                              seconds: 90,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '36',
                  key: 'long_size_option_120',
                  name: 'Long Video (120sec)',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '64',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 600,
                                height: 900,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 6,
                                height: 5,
                              },
                              presetSize: {
                                width: 300,
                                height: 250,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '63',
                          availables: [
                            {
                              seconds: 100,
                            },
                            {
                              seconds: 110,
                            },
                            {
                              seconds: 120,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '37',
                  key: 'long_size_option_150',
                  name: 'Long Video (150sec)',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '66',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 600,
                                height: 900,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 6,
                                height: 5,
                              },
                              presetSize: {
                                width: 300,
                                height: 250,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '65',
                          availables: [
                            {
                              seconds: 130,
                            },
                            {
                              seconds: 140,
                            },
                            {
                              seconds: 150,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '38',
                  key: 'long_size_option_180',
                  name: 'Long Video (180sec)',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '68',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 600,
                                height: 900,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 6,
                                height: 5,
                              },
                              presetSize: {
                                width: 300,
                                height: 250,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '67',
                          availables: [
                            {
                              seconds: 160,
                            },
                            {
                              seconds: 170,
                            },
                            {
                              seconds: 180,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        creativeBriefDefinition: {
          id: '880',
          sections: [
            {
              id: '35405036-0E8F-46AD-A0E7-811F21E694A8',
              label: '案件詳細',
              description: '動画広告を考えている商品について、以下を記載してみましょう！',
              meta: null,
              fields: [
                {
                  key: '59C3B461-A1CC-49BB-8138-CF792978A495',
                  type: 'MULTI_LINE_TEXT',
                  label: '商品/サービス',
                  placeholder: '例)Kaizen Ad',
                  helperText: '',
                  isRequired: false,
                },
                {
                  key: '268711DB-9DCC-4175-A747-BF20848FC50F',
                  type: 'MULTI_LINE_TEXT',
                  label: '関連URL',
                  placeholder: '例)https://ja.kaizen-ad.com/',
                  helperText: '',
                  isRequired: false,
                },
                {
                  key: '9B706205-2082-4D69-9AEA-4A2860FCA7AF',
                  type: 'MULTI_LINE_TEXT',
                  label: 'ペルソナ',
                  placeholder:
                    '例)\n動画広告を考えているマーケティング担当者。\n動画広告を打ちたいがあまり予算を持つことが難しい担当者。',
                  helperText: '',
                  isRequired: false,
                },
                {
                  key: '114CDB1A-1AAA-459A-B436-9EF980A68F3A',
                  type: 'MULTI_LINE_TEXT',
                  label: '広告の目的（KPI）',
                  placeholder: '例)資料ダウンロード・問い合わせ',
                  helperText: '',
                  isRequired: false,
                },
              ],
            },
            {
              id: '0B5B4218-21A2-256D-D6AF-19626C2D7B23',
              label: '制作仕様',
              description:
                '最終的に納品されるクリエイティブのフォーマットについて教えてください。プロジェクトタイプによっては固定されています。',
              meta: null,
              fields: [
                {
                  key: 'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA4',
                  type: 'FIXED',
                  label: '形式',
                  value: '動画（mp4）',
                },
                {
                  key: 'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA3',
                  type: 'SELECT_ONE',
                  label: 'サウンド',
                  choices: [
                    {
                      key: '有',
                      label: '有',
                    },
                    {
                      key: '無',
                      label: '無',
                    },
                  ],
                  helperText:
                    '音声有りの場合は音声ファイルのご用意をお願いいたします。音声ファイルをご提供いただけない場合は作成できませんので、「無」を選択してください。',
                },
              ],
            },
            {
              id: '8DB5ED50-482E-4BDB-9227-40914C7099A0',
              label: '動画構成',
              description: '動画の構成を指示してください。',
              meta: null,
              fields: [
                {
                  key: '2F0D2C92-A694-42ED-AE58-43EB3629A665',
                  type: 'MULTI_LINE_TEXT',
                  label: '構成',
                  placeholder:
                    '例)\n以下の内容で制作をお願いします\n構成：問題定義→解決方法→追加説明→オファー\n表現：画面分割の演出を盛り込んでください\nテイスト：スタイリッシュなイメージ\n\n1.（問題提起）\n動画は高い...\n動画は遅い...\n動画のクオリティーは安定しない...\n\n2.（解決方法）\nKaizen Adなら1本5万円から、最短5分で発注、5営業日で初稿納品が可能！\n\n3.（追加説明）\n「累計10,000クリエイティブ制作の実績あり！」「APAC唯一のFacebook/Google社の認定パートナー」だからクオリティも安心。おまけにノウハウも兼ね揃えています！\n上記訴求ポイントを伝えつつ、過去の動画事例を画面分割で表示してください。\n\n4.（エンドカット）\n豊富な動画事例を掲載した資料DLはこちら',
                  helperText: '',
                  isRequired: false,
                },
              ],
            },
            {
              id: '1B5B4218-21A2-256D-D6AF-19626C2D7B23',
              label: 'レギュレーション',
              description:
                'クリエイティブを制作する上で必須なブランド規定や関連法規(薬事法・景品表示法)がある場合は記入してください。こちらで記入された事項についての修正は、無償でクリエイターに依頼できます。',
              meta: null,
              fields: [
                {
                  key: 'E6810179-60AC-4BBD-A716-522CFEEC660F',
                  type: 'MULTI_LINE_TEXT',
                  label: '制作する上でのレギュレーション',
                  placeholder:
                    '例)\n・トンマナ/フォントについてはWebサイトに準ずる\n・ロゴは縦横比変更不可\n・Kaizen Adのロゴを右上に常設してください\n・コピーライト「©︎株式会社Kazien Platform」を表示してください',
                  helperText: '制作する上でクリエイターに必ず守っていただきたいことを記載してください。',
                  isRequired: false,
                },
              ],
            },
          ],
        },
        creativeBriefValues: {
          '114CDB1A-1AAA-459A-B436-9EF980A68F3A': '例)資料ダウンロード・問い合わせ',
          '268711DB-9DCC-4175-A747-BF20848FC50F': '例)https://ja.kaizen-ad.com/',
          '2F0D2C92-A694-42ED-AE58-43EB3629A665':
            '例)\n以下の内容で制作をお願いします\n構成：問題定義→解決方法→追加説明→オファー\n表現：画面分割の演出を盛り込んでください\nテイスト：スタイリッシュなイメージ\n\n1.（問題提起）\n動画は高い...\n動画は遅い...\n動画のクオリティーは安定しない...\n\n2.（解決方法）\nKaizenAdなら1本5万円から、最短5分で発注、5営業日で初稿納品が可能！\n\n3.（追加説明）\n「累計10,000クリエイティブ制作の実績あり！」「APAC唯一のFacebook/Google社の認定パートナー」だからクオリティも安心。おまけにノウハウも兼ね揃えています！\n上記訴求ポイントを伝えつつ、過去の動画事例を画面分割で表示してください。\n\n4.（エンドカット）\n豊富な動画事例を掲載した資料DLはこちら',
          '59C3B461-A1CC-49BB-8138-CF792978A495': '例)Kaizen Ad',
          '9B706205-2082-4D69-9AEA-4A2860FCA7AF':
            '例)\n動画広告を考えているマーケティング担当者。\n動画広告を打ちたいがあまり予算を持つことが難しい担当者。',
          'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA3': '有',
          'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA4': '動画（mp4）',
          'E6810179-60AC-4BBD-A716-522CFEEC660F':
            '例)\n・ロゴは縦横比変更不可\n・コピーライト「©Kaizen Platform, Inc. 2019」を表示してください',
        },
        bucketId: '7c2e2905-4ffa-4963-a43c-1477824f3172',
        assetCategoryDefinition: {
          id: '1110',
          sections: [
            {
              id: '0a3dd0dd-611d-47c8-b38e-aad399fba0f3',
              meta: {
                helperUrl: 'https://help.kaizen-ad.com/ja/articles/4095148',
                isRequired: true,
                allowSearchTypes: [],
                allowRecommendTypes: [],
                audioPreparedMaterialIds: [],
                imagePreparedMaterialIds: [],
                videoPreparedMaterialIds: [],
                isAllowLeaveToTheCreators: false,
              },
              label: '',
              description:
                '■必要素材(最低1つのファイルをアップロードいただくか、URLの入力が必要です。複数選択可能)\n・LP/静止画バナー(ai/psdデータ推奨)\n・画像(png/jpg/bmp推奨)\n・動画(白素材データ+各音声データ推奨)\n・チラシ/パンフレットデータ(aiデータ推奨)\n・資料（パワーポイントなど）\n\n※ 以前制作した動画のリサイズをご発注の場合は下記データが必須素材となります\n・オリジナルの動画(mp4)\n\n※ 【オプション】ナレーションをご発注の場合は、下記データのご準備をお願いいたします\n・ナレーションをつける動画ファイル（mp4）\n・ナレーション原稿（Excel,word,pdfなど）\n・（必要がある場合のみ）BGM音源',
              fields: [
                {
                  key: '3ef3d9a7-062b-4f96-be6e-61adc7fc1b99',
                  type: 'FILE_IDS',
                  label: 'ファイルを選択',
                },
                {
                  key: 'bd1d10a5-0c68-42d2-bf3c-2ceed06e1787',
                  type: 'SINGLE_LINE_TEXT',
                  label: '共有ファイルのURL',
                  placeholder: 'https://',
                  helperText: '共有ファイルのURL',
                  isRequired: false,
                },
                {
                  key: '643df670-9be0-4bbf-b709-6c29e7900cea',
                  type: 'MULTI_LINE_TEXT',
                  label: '補足事項',
                  placeholder: '注意事項やパスワードなど',
                  helperText: '補足事項',
                  isRequired: false,
                },
                {
                  key: 'e907e43b-f263-4ef1-be99-d1f91524adda',
                  type: 'SELECT_ONE',
                  label: '素材を準備しますか？',
                  choices: [
                    {
                      key: 'leave to the creators',
                      label: 'クリエイターに任せる',
                    },
                    {
                      key: 'make your own choice',
                      label: '自分で選ぶ',
                    },
                  ],
                  helperText: '素材を準備しますか？',
                },
              ],
            },
          ],
        },
        assetCategoryValues: {
          '3ef3d9a7-062b-4f96-be6e-61adc7fc1b99': [
            '19f0bcd6-0810-4334-89e7-bfb1b7af45bf',
            '37fe8de1-cd14-45eb-9f1a-a615ff32de8c',
            '3a434738-6c24-4d3d-bd99-1ed8652a6cb2',
            '7844bbac-c5d2-44ba-a41b-2a64633a5074',
            'bf1464ac-4c49-4fb2-bc0b-4983e9a9c5e9',
            'c0344bb3-3359-4753-9c8d-4595c5af5c07',
            'e9b7a28c-0bde-4e38-94d1-2cc992155716',
          ],
          '643df670-9be0-4bbf-b709-6c29e7900cea': '※BGMは動画に適したものを3曲の中から選定してください。',
          'bd1d10a5-0c68-42d2-bf3c-2ceed06e1787': '',
          'e907e43b-f263-4ef1-be99-d1f91524adda': 'make your own choice',
        },
        creationSet: getDemoCreationSet('CS01FKZ3RCDWM2') as CreationSetForShowFragment,
        performanceReports: [],
        createdAt: '2021-11-08T06:28:50Z',
        submittedAt: '2019-10-28T08:40:30Z',
        adVideos: [],
        issue: null,
        progressSummary: {
          orderCount: 1,
          approvedCount: 1,
          modificationRequestCount: 0,
          modificationRequestFeedbackCount: 0,
        },
      },
    },
  },
  {
    data: {
      project: {
        id: 'PJ01FKQWW7370Q',
        finalized: false,
        versionId: '22557',
        matchingFormat: 'auto',
        organization: {
          id: '29067',
          name: '牧野フライス製作所（Sales）',
          pointBalance: 160,
          features: {
            canOpenOfferWhenDisagreed: false,
          },
          businessRegion: {
            key: 'jp',
            idBusinessRegion: 'japan',
            timeZone: 'Asia/Tokyo',
          },
        },
        originId: 'PJ01FKQWW7370Q',
        parentId: null,
        title: '【KAIZEN証券】20190524_iDeCo資料請求訴求',
        state: 'assigned',
        createdBy: {
          id: '17578',
          name: 'Kaizen CS umemura',
          profileImageUrl: '',
        },
        designInspirationCase: null,
        projectType: {
          id: '182',
          published: false,
          version: 2,
          title: 'プロジェクトタイプ -デモ用-',
          description: 'これはデモプロジェクトタイプです。本発注にはご利用いただけません。',
          thumbnailImageUrl:
            '//assets-ad.kaizenplatform.net/project_types/411/%E3%83%86%E3%82%AD%E3%82%B9%E3%83%88%E3%81%AE%E3%81%BF%E3%81%AE%E5%8B%95%E7%94%BB%E5%8C%96.png?1560239905',
          sampleVideoUrl:
            '//assets-ad.kaizenplatform.net/project_types/412/%E3%83%86%E3%82%AD%E3%82%B9%E3%83%88%E3%81%AE%E3%81%BF%E3%81%AE%E5%8B%95%E7%94%BB%E5%8C%96.mp4?1560239905',
          expectedDeliveryPeriod: '3-5営業日',
          outputSpecification: '以下の仕様で制作依頼が可能です。 　 ファイル形式: 動画(mp4形式) 　 サウンド: 指定可',
          regulation:
            '提供必須なもの \r\n・静止画バナーまたはランディングページ素材（aiデータ/Adobe Illustrator形式またはPhotoshopファイル/psd形式）\r\n※ai/psdについてはZIPファイルにて格納をお願い致します。\r\n・ロゴデータ\r\n\r\n必要に応じて提供するもの\r\n・各種レギュレーション規定資料\r\n※ ロゴや素材の取扱規定・クリエイティブのトーン＆マナー規定など',
          creativeBriefDefinition: {
            id: '824',
            sections: [
              {
                id: '00FC8A39-8E9D-4E0A-8E37-571C0FE45709',
                label: '商品・サービスについて',
                description: 'クリエイティブ制作の対象となる商品・サービスの情報を記入してください。',
                fields: [
                  {
                    key: '5CD5F04C-3A3E-48BD-91BA-10227466D115',
                    type: 'SINGLE_LINE_TEXT',
                    label: '商品・サービス名',
                    placeholder: '例) Kaizen Ad',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: 'AD6FBD0A-5F67-497B-984D-9D3CEC1D073D',
                    type: 'SINGLE_LINE_TEXT',
                    label: '関連URL',
                    placeholder: '例) https://ja.kaizen-ad.com/',
                    helperText: '商品・サービスを紹介するサイトがあれば記入してください。',
                    isRequired: false,
                  },
                  {
                    key: 'FFEFDFD0-B4FF-49E7-BAE5-771DE2C09FF5',
                    type: 'MULTI_LINE_TEXT',
                    label: '概要',
                    placeholder:
                      '例) Kaizen Adはクリエイティブを軸にFacebook動画広告の改善を行えるサービスです。世界中の8,000名の多種多様なクリエイターに制作を依頼でき、豊富なバリエーションを集めることができます。高い効果を得るために継続的な広告の入れ替えをサポートします。',
                    helperText: '商品・サービスの概要や特徴について記入してください。',
                    isRequired: false,
                  },
                ],
              },
              {
                id: '0B5B4218-21A2-256D-D6AF-19626C2D7B23',
                label: '制作仕様',
                description:
                  '最終的に納品されるクリエイティブのフォーマットについて教えてください。プロジェクトタイプによっては固定されています。',
                fields: [
                  {
                    key: 'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA4',
                    type: 'FIXED',
                    label: '形式',
                    value: '動画（mp4）',
                  },
                  {
                    key: 'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA3',
                    type: 'SELECT_ONE',
                    label: 'サウンド',
                    choices: [
                      {
                        key: '有',
                        label: '有',
                      },
                      {
                        key: '無',
                        label: '無',
                      },
                    ],
                    helperText:
                      '音声有りの場合は音声ファイルのご用意をお願いいたします。音声ファイルをご提供いただけない場合は作成できませんので、「無」を選択してください。',
                  },
                ],
              },
              {
                id: '3DCC194F-96A1-6FFC-6821-BF0BDFFAC4D7',
                label: 'ターゲットについて',
                description:
                  '誰向けのクリエイティブを制作するのか教えてください。クリエイターがより効果の高いクリエイティブを制作するための参考にします。',
                fields: [
                  {
                    key: '1CF9DCCD-B35F-4D69-7413-6F7764F01732',
                    type: 'SELECT_MULTIPLE',
                    label: '年齢',
                    choices: [
                      {
                        key: "10's",
                        label: '10代',
                      },
                      {
                        key: "20's",
                        label: '20代',
                      },
                      {
                        key: "30's",
                        label: '30代',
                      },
                      {
                        key: "40's",
                        label: '40代',
                      },
                      {
                        key: "50's",
                        label: '50代',
                      },
                      {
                        key: "60's or above",
                        label: '60代以上',
                      },
                    ],
                    helperText: '',
                    isRequiredToSelectAnything: false,
                  },
                  {
                    key: 'C3AD336E-C74D-D420-15DE-3C4C59AB82C1',
                    type: 'SELECT_ONE',
                    label: '性別',
                    choices: [
                      {
                        key: 'All',
                        label: '全て',
                      },
                      {
                        key: 'Men',
                        label: '男性',
                      },
                      {
                        key: 'Women',
                        label: '女性',
                      },
                    ],
                    helperText: '',
                  },
                  {
                    key: 'BCD24650-4F57-43FB-947E-93587B14C3B4',
                    type: 'SINGLE_LINE_TEXT',
                    label: '地域',
                    placeholder: '例)日本',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: 'DB6767F4-C68C-7188-1D1C-6DF9BAFB3048',
                    type: 'SINGLE_LINE_TEXT',
                    label: '言語',
                    placeholder: '例)日本語',
                    helperText: '',
                    isRequired: false,
                  },
                ],
              },
              {
                id: '3C1F9583-5D94-B30F-34EF-5B8121AF7972',
                label: '広告の目的',
                description:
                  '広告を見せることでターゲットに引き起こしたい認知や態度の変化について教えてください。グロースハッカーがターゲットの態度の変化を促す効果的な表現や見せ方を考えます。',
                fields: [
                  {
                    key: '154898A6-818C-F980-E2E6-6B63658D60CB',
                    type: 'MULTI_LINE_TEXT',
                    label: 'ターゲットの人物像・特徴・ペルソナ',
                    placeholder: '例)・KAIZEN Adに興味を持っている方・KAIZEN Adの利用を検討されている方',
                    helperText: 'クリエイティブを見る前のターゲットの人物像、特徴やペルソナを教えてください',
                    isRequired: false,
                  },
                  {
                    key: '5C53163B-5814-52BC-D97D-95FFF936AD3F',
                    type: 'MULTI_LINE_TEXT',
                    label: 'KPI',
                    placeholder: '例) サイト誘導からの問い合わせ。',
                    helperText: 'この動画広告のKPIを教えてください',
                    isRequired: false,
                  },
                ],
              },
              {
                id: 'C664CF24-8FCC-494F-ABAB-EC6B1FE4669F',
                label: '制作指示',
                description: '具体的な制作指示をこちらに記述してください。',
                fields: [
                  {
                    key: 'B2E510C5-1D15-43F0-A785-E03E05475FCD',
                    type: 'MULTI_LINE_TEXT',
                    label: '全体',
                    placeholder:
                      '例）\n・全体の印象をポップで、アニメーションのスピードを早めた動画にしていただきたいです。',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: 'D9FEAF78-87FF-40A0-9401-431C2C4472A0',
                    type: 'MULTI_LINE_TEXT',
                    label: 'シーン1で使用するテキスト/文言',
                    placeholder:
                      '例）\n・「Kaizen Adは、速く・安く・簡単に、高品質な動画を制作できるプラットフォームです。」という文言をお使いください。',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: 'CD7D27B6-2D59-4C69-AB07-7CF52D07F377',
                    type: 'MULTI_LINE_TEXT',
                    label: 'シーン2で使用するテキスト/文言',
                    placeholder:
                      '例）\n・「限りなく手間を削減した発注システムと10,000人規模のクリエイターネットワークを構築」という文言をはじめに使用してください。\n・「動画を企業にとってより一層身近なものにし、最小限の労力で最大限のパフォーマンスを得られる環境をご提供します」を次に使用してください。',
                    helperText: '',
                    isRequired: false,
                  },
                  {
                    key: 'DCE45367-006F-43FA-BBD7-FEB0DBCFD05F',
                    type: 'MULTI_LINE_TEXT',
                    label: 'シーン3で使用するテキスト/文言',
                    placeholder:
                      '例）\n・「サービスについてもっと知りたい方は、資料ダウンロード」という文言を使い、資料ダウンロードを促すアニメーションを追加してください。',
                    helperText: '',
                    isRequired: false,
                  },
                ],
              },
              {
                id: '1B5B4218-21A2-256D-D6AF-19626C2D7B23',
                label: 'レギュレーション',
                description:
                  'クリエイティブを制作する上で必須なブランド規定や関連法規(薬事法・景品表示法)がある場合は記入してください。こちらで記入された事項についての修正は、無償でクリエイターに依頼できます。',
                fields: [
                  {
                    key: '254898A6-818C-F980-E2E6-6B63658D60CB',
                    type: 'MULTI_LINE_TEXT',
                    label: '素材のレギュレーション',
                    placeholder:
                      '例)\n・ロゴの使用については、素材にて添付しておりますPDFをご覧ください。\n・タレントの顔に文字などが被らないように使用してください。\n',
                    helperText: '\b使用する素材についてのレギュレーションをご記載ください。',
                    isRequired: false,
                  },
                  {
                    key: 'E6810179-60AC-4BBD-A716-522CFEEC660F',
                    type: 'MULTI_LINE_TEXT',
                    label: '制作する上でのレギュレーション',
                    placeholder:
                      '例）\r\n・KaizenAdのロゴは必ず常設してください。\n・画面内にKaizenAdの文字が表示されているときは、ロゴを外してください。\n・\bトンマナについてはサイトのURLをご覧ください。',
                    helperText: '制作する上でクリエイターに必ず守っていただきたいことを記載してください。',
                    isRequired: false,
                  },
                ],
              },
            ],
          },
          assetCategoryDefinition: {
            id: '1136',
            sections: [
              {
                id: '0a3dd0dd-611d-47c8-b38e-aad399fba0f3',
                meta: {
                  helperUrl: 'https://help.kaizen-ad.com/ja/articles/4095148',
                  isRequired: true,
                  allowSearchTypes: [],
                  allowRecommendTypes: [],
                  audioPreparedMaterialIds: [],
                  imagePreparedMaterialIds: [],
                  videoPreparedMaterialIds: [],
                  isAllowLeaveToTheCreators: false,
                },
                label: '',
                description:
                  '■必要素材(最低1つのファイルをアップロードいただくか、URLの入力が必要です。複数選択可能)\n・LP/静止画バナー(ai/psdデータ推奨)\n・画像(png/jpg/bmp推奨)\n・動画(白素材データ+各音声データ推奨)\n・チラシ/パンフレットデータ(aiデータ推奨)\n・資料（パワーポイントなど）\n\n※ 以前制作した動画のリサイズをご発注の場合は下記データが必須素材となります\n・オリジナルの動画(mp4)\n\n※ 【オプション】ナレーションをご発注の場合は、下記データのご準備をお願いいたします\n・ナレーションをつける動画ファイル（mp4）\n・ナレーション原稿（Excel,word,pdfなど）\n・（必要がある場合のみ）BGM音源',
                fields: [
                  {
                    key: '3ef3d9a7-062b-4f96-be6e-61adc7fc1b99',
                    type: 'FILE_IDS',
                    label: 'ファイルを選択',
                  },
                  {
                    key: 'bd1d10a5-0c68-42d2-bf3c-2ceed06e1787',
                    type: 'SINGLE_LINE_TEXT',
                    label: '共有ファイルのURL',
                    placeholder: 'https://',
                    helperText: '共有ファイルのURL',
                    isRequired: false,
                  },
                  {
                    key: '643df670-9be0-4bbf-b709-6c29e7900cea',
                    type: 'MULTI_LINE_TEXT',
                    label: '補足事項',
                    placeholder: '注意事項やパスワードなど',
                    helperText: '補足事項',
                    isRequired: false,
                  },
                  {
                    key: 'e907e43b-f263-4ef1-be99-d1f91524adda',
                    type: 'SELECT_ONE',
                    label: '素材を準備しますか？',
                    choices: [
                      {
                        key: 'leave to the creators',
                        label: 'クリエイターに任せる',
                      },
                      {
                        key: 'make your own choice',
                        label: '自分で選ぶ',
                      },
                    ],
                    helperText: '素材を準備しますか？',
                  },
                ],
              },
            ],
          },
          supportingCreativeFormatNetworks: [
            {
              id: '2',
              key: 'facebook',
              name: 'Facebook',
              placements: [
                {
                  id: '2',
                  key: 'facebook_feeds',
                  name: 'Feeds',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '1',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '2',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '3',
                  key: 'facebook_in_stream',
                  name: 'In-Stream',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '3',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '4',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '3',
              key: 'instagram',
              name: 'Instagram',
              placements: [
                {
                  id: '4',
                  key: 'instagram_feeds',
                  name: 'Feeds',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '5',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '6',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '5',
                  key: 'instagram_stories',
                  name: 'Stories',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '7',
                          availables: [
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '8',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '5',
              key: 'youtube',
              name: 'YouTube',
              placements: [
                {
                  id: '7',
                  key: 'youtube_trueview',
                  name: 'TrueView',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '11',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 840,
                                height: 1260,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '12',
                          availables: [
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '8',
                  key: 'youtube_non_skippable_video_ads',
                  name: 'Non-skippable video ads',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '13',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '14',
                          availables: [
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '9',
                  key: 'youtube_bumper_ads',
                  name: 'Bumper ads',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '15',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 2,
                                height: 3,
                              },
                              presetSize: {
                                width: 840,
                                height: 1260,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '16',
                          availables: [
                            {
                              seconds: 6,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '6',
              key: 'twitter',
              name: 'Twitter',
              placements: [
                {
                  id: '11',
                  key: 'twitter_promoted_video_in_stream',
                  name: 'Promoted Video / In-Stream',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '18',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '19',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '7',
              key: 'line',
              name: 'LINE',
              placements: [
                {
                  id: '12',
                  key: 'line_any_placement',
                  name: 'Any Placement',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '20',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '21',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '8',
              key: 'yahoo',
              name: 'Yahoo',
              placements: [
                {
                  id: '13',
                  key: 'yahoo_any_placement',
                  name: 'Any Placement',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '22',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 640,
                                height: 360,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 600,
                                height: 600,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '23',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
                {
                  id: '14',
                  key: 'jp_yahoo_brand_panel',
                  name: 'ブランドパネル',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '24',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 640,
                                height: 360,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 600,
                                height: 600,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '25',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: '9',
              key: 'google',
              name: 'Google',
              placements: [
                {
                  id: '15',
                  key: 'google_any_placement',
                  name: 'Any Placement',
                  basicMerchandises: [
                    {
                      isResizable: true,
                      creativeType: {
                        id: '1',
                        key: 'video',
                        name: 'Video',
                      },
                    },
                    {
                      isResizable: true,
                      creativeType: {
                        id: '2',
                        key: 'static_image',
                        name: 'Static Image',
                      },
                    },
                  ],
                  creativeTypes: [
                    {
                      id: '1',
                      key: 'video',
                      name: 'Video',
                      attribute: {
                        aspectRatio: {
                          id: '26',
                          availables: [
                            {
                              aspectRatio: {
                                width: 16,
                                height: 9,
                              },
                              presetSize: {
                                width: 1920,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 1,
                                height: 1,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1080,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 9,
                                height: 16,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1920,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 4,
                                height: 5,
                              },
                              presetSize: {
                                width: 1080,
                                height: 1350,
                              },
                            },
                            {
                              aspectRatio: {
                                width: 6,
                                height: 5,
                              },
                              presetSize: {
                                width: 300,
                                height: 250,
                              },
                            },
                          ],
                        },
                        playbackTime: {
                          id: '27',
                          availables: [
                            {
                              seconds: 7,
                            },
                            {
                              seconds: 10,
                            },
                            {
                              seconds: 15,
                            },
                            {
                              seconds: 20,
                            },
                            {
                              seconds: 25,
                            },
                            {
                              seconds: 30,
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        creativeBriefDefinition: {
          id: '690',
          sections: [
            {
              id: '00FC8A39-8E9D-4E0A-8E37-571C0FE45709',
              label: '商品・サービスについて',
              description: 'クリエイティブ制作の対象となる商品・サービスの情報を記入してください。',
              meta: null,
              fields: [
                {
                  key: '5CD5F04C-3A3E-48BD-91BA-10227466D115',
                  type: 'SINGLE_LINE_TEXT',
                  label: '商品・サービス名',
                  placeholder: '例) Kaizen Ad',
                  helperText: '',
                  isRequired: false,
                },
                {
                  key: 'AD6FBD0A-5F67-497B-984D-9D3CEC1D073D',
                  type: 'SINGLE_LINE_TEXT',
                  label: '関連URL',
                  placeholder: '例) https://ja.kaizen-ad.com/',
                  helperText: '商品・サービスを紹介するサイトがあれば記入してください。',
                  isRequired: false,
                },
                {
                  key: 'FFEFDFD0-B4FF-49E7-BAE5-771DE2C09FF5',
                  type: 'MULTI_LINE_TEXT',
                  label: '概要',
                  placeholder:
                    '例) Kaizen Adはクリエイティブを軸にFacebook動画広告の改善を行えるサービスです。世界中の8,000名の多種多様なクリエイターに制作を依頼でき、豊富なバリエーションを集めることができます。高い効果を得るために継続的な広告の入れ替えをサポートします。',
                  helperText: '商品・サービスの概要や特徴について記入してください。',
                  isRequired: false,
                },
              ],
            },
            {
              id: '0B5B4218-21A2-256D-D6AF-19626C2D7B23',
              label: '制作仕様',
              description:
                '最終的に納品されるクリエイティブのフォーマットについて教えてください。プロジェクトタイプによっては固定されています。',
              meta: null,
              fields: [
                {
                  key: 'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA4',
                  type: 'FIXED',
                  label: '形式',
                  value: '動画（mp4）',
                },
                {
                  key: 'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA3',
                  type: 'SELECT_ONE',
                  label: 'サウンド',
                  choices: [
                    {
                      key: '有',
                      label: '有',
                    },
                    {
                      key: '無',
                      label: '無',
                    },
                  ],
                  helperText:
                    '音声有りの場合は音声ファイルのご用意をお願いいたします。音声ファイルをご提供いただけない場合は作成できませんので、「無」を選択してください。',
                },
              ],
            },
            {
              id: '3DCC194F-96A1-6FFC-6821-BF0BDFFAC4D7',
              label: 'ターゲットについて',
              description:
                '誰向けのクリエイティブを制作するのか教えてください。クリエイターがより効果の高いクリエイティブを制作するための参考にします。',
              meta: null,
              fields: [
                {
                  key: '1CF9DCCD-B35F-4D69-7413-6F7764F01732',
                  type: 'SELECT_MULTIPLE',
                  label: '年齢',
                  choices: [
                    {
                      key: "10's",
                      label: '10代',
                    },
                    {
                      key: "20's",
                      label: '20代',
                    },
                    {
                      key: "30's",
                      label: '30代',
                    },
                    {
                      key: "40's",
                      label: '40代',
                    },
                    {
                      key: "50's",
                      label: '50代',
                    },
                    {
                      key: "60's or above",
                      label: '60代以上',
                    },
                  ],
                  helperText: '',
                  isRequiredToSelectAnything: false,
                },
                {
                  key: 'C3AD336E-C74D-D420-15DE-3C4C59AB82C1',
                  type: 'SELECT_ONE',
                  label: '性別',
                  choices: [
                    {
                      key: 'All',
                      label: '全て',
                    },
                    {
                      key: 'Men',
                      label: '男性',
                    },
                    {
                      key: 'Women',
                      label: '女性',
                    },
                  ],
                  helperText: '',
                },
                {
                  key: 'BCD24650-4F57-43FB-947E-93587B14C3B4',
                  type: 'SINGLE_LINE_TEXT',
                  label: '地域',
                  placeholder: '例)日本',
                  helperText: '',
                  isRequired: false,
                },
                {
                  key: 'DB6767F4-C68C-7188-1D1C-6DF9BAFB3048',
                  type: 'SINGLE_LINE_TEXT',
                  label: '言語',
                  placeholder: '例)日本語',
                  helperText: '',
                  isRequired: false,
                },
              ],
            },
            {
              id: '3C1F9583-5D94-B30F-34EF-5B8121AF7972',
              label: '広告の目的',
              description:
                '広告を見せることでターゲットに引き起こしたい認知や態度の変化について教えてください。グロースハッカーがターゲットの態度の変化を促す効果的な表現や見せ方を考えます。',
              meta: null,
              fields: [
                {
                  key: '154898A6-818C-F980-E2E6-6B63658D60CB',
                  type: 'MULTI_LINE_TEXT',
                  label: 'ターゲットの人物像・特徴・ペルソナ',
                  placeholder: '例)\n・KAIZEN Adに興味を持っている方\n・KAIZEN Adの利用を検討されている方',
                  helperText: 'クリエイティブを見る前のターゲットの人物像、特徴やペルソナを教えてください',
                  isRequired: false,
                },
                {
                  key: '5C53163B-5814-52BC-D97D-95FFF936AD3F',
                  type: 'MULTI_LINE_TEXT',
                  label: 'ターゲットの変化',
                  placeholder: '例）\n・動画がこんなにも簡単に作れて、効果も出せるならKaizenAdを利用してみたい',
                  helperText:
                    'クリエイティブを見ることで引き起こしたいターゲットの心境や態度の変化について教えてください',
                  isRequired: false,
                },
              ],
            },
            {
              id: 'C664CF24-8FCC-494F-ABAB-EC6B1FE4669F',
              label: '制作指示',
              description: '具体的な制作指示をこちらに記述してください。',
              meta: null,
              fields: [
                {
                  key: 'B2E510C5-1D15-43F0-A785-E03E05475FCD',
                  type: 'MULTI_LINE_TEXT',
                  label: '全体',
                  placeholder:
                    '例）\n・全体の印象をポップで、アニメーションのスピードを早めた動画にしていただきたいです。',
                  helperText: '',
                  isRequired: false,
                },
                {
                  key: 'D9FEAF78-87FF-40A0-9401-431C2C4472A0',
                  type: 'MULTI_LINE_TEXT',
                  label: 'シーン1で使用するテキスト/文言',
                  placeholder:
                    '例）\n・「Kaizen Adは、速く・安く・簡単に、高品質な動画を制作できるプラットフォームです。」という文言をお使いください。',
                  helperText: '',
                  isRequired: false,
                },
                {
                  key: 'CD7D27B6-2D59-4C69-AB07-7CF52D07F377',
                  type: 'MULTI_LINE_TEXT',
                  label: 'シーン2で使用するテキスト/文言',
                  placeholder:
                    '例）\n・「限りなく手間を削減した発注システムと10,000人規模のクリエイターネットワークを構築」という文言をはじめに使用してください。\n・「動画を企業にとってより一層身近なものにし、最小限の労力で最大限のパフォーマンスを得られる環境をご提供します」を次に使用してください。',
                  helperText: '',
                  isRequired: false,
                },
                {
                  key: 'DCE45367-006F-43FA-BBD7-FEB0DBCFD05F',
                  type: 'MULTI_LINE_TEXT',
                  label: 'シーン3で使用するテキスト/文言',
                  placeholder:
                    '例）\n・「サービスについてもっと知りたい方は、資料ダウンロード」という文言を使い、資料ダウンロードを促すアニメーションを追加してください。',
                  helperText: '',
                  isRequired: false,
                },
              ],
            },
            {
              id: '1B5B4218-21A2-256D-D6AF-19626C2D7B23',
              label: 'レギュレーション',
              description:
                'クリエイティブを制作する上で必須なブランド規定や関連法規(薬事法・景品表示法)がある場合は記入してください。こちらで記入された事項についての修正は、無償でクリエイターに依頼できます。',
              meta: null,
              fields: [
                {
                  key: '254898A6-818C-F980-E2E6-6B63658D60CB',
                  type: 'MULTI_LINE_TEXT',
                  label: '素材のレギュレーション',
                  placeholder:
                    '例)\n・ロゴの使用については、素材にて添付しておりますPDFをご覧ください。\n・タレントの顔に文字などが被らないように使用してください。\n',
                  helperText: '\b使用する素材についてのレギュレーションをご記載ください。',
                  isRequired: false,
                },
                {
                  key: 'E6810179-60AC-4BBD-A716-522CFEEC660F',
                  type: 'MULTI_LINE_TEXT',
                  label: '制作する上でのレギュレーション',
                  placeholder:
                    '例）\r\n・KaizenAdのロゴは必ず常設してください。\n・画面内にKaizenAdの文字が表示されているときは、ロゴを外してください。\n・\bトンマナについてはサイトのURLをご覧ください。',
                  helperText: '制作する上でクリエイターに必ず守っていただきたいことを記載してください。',
                  isRequired: false,
                },
              ],
            },
          ],
        },
        creativeBriefValues: {
          '154898A6-818C-F980-E2E6-6B63658D60CB':
            '・商品についての認知：iDeCo自体は知っている\n・商品への興味：漠然と将来が不安だと思っている、投資に興味がある\n・商品に関して起こした行動：一通りiDeCoについて調べたが、申し込んではいない\n・ターゲットの性格など：慎重で、きちんと情報を集めてから判断したい',
          '1CF9DCCD-B35F-4D69-7413-6F7764F01732': ["20's", "30's", "40's"],
          '254898A6-818C-F980-E2E6-6B63658D60CB': '・ロゴの変形/色の変更はしないでください。',
          '5C53163B-5814-52BC-D97D-95FFF936AD3F':
            '【本動画を使ったプロモーションの流れ】\nFacebookで動画を広告配信。動画を見たユーザーをLPに遷移させ、LP内資料請求フォームで申し込みしてもらうよう誘導する。\n\n【ユーザーの心境の変化】\n・（動画を見る前）どこのiDeCoがいいんだろう\n・（動画視聴）\n1、運営手数料無料で始められるんだ！\n2、いくつかバリエーションがあるんだ！口座管理もできるんだ！\n・（動画を見た後）もともと興味はあったし、資料請求して詳しく見てみよう',
          '5CD5F04C-3A3E-48BD-91BA-10227466D115': 'KAIZEN証券のiDeCo',
          'AD6FBD0A-5F67-497B-984D-9D3CEC1D073D': 'https://kaizenplatform.com/',
          'B2E510C5-1D15-43F0-A785-E03E05475FCD':
            '【表現】\n・文字を中心に動きをつけていただき、インパクトのある動画にしてください。\n特に意識していただきたいのは下記です。\n　・文字サイズは大きめ\n　・コピーの中でも、強調部分とそうでない部分のデザインや文字サイズのメリハリ\n　・テンポ感（可読性が高く、かつ最後まで飽きずに見られる）\n\n【参考イメージ動画】\nhttps://youtu.be/Ryz5fYGOzsA\n\n【内容】\n・バナーの3訴求は全て入れていただきたいですが、実際の申込者には「誰でも、条件なしで\n運営管理手数料0円」がいちばん刺さっているので、手数料0円をメインで押し出してください。\n・KAIZEN証券のロゴを常設してください。\n・0円と出している画面では、必ず「※」印で書かれている注釈を表示してください。\n\n【避けたい表現】\n・金融商品なので、ポップすぎる表現は避けてください。\n・パワーポイントのスライドショーのような表現はやめてください。',
          'BCD24650-4F57-43FB-947E-93587B14C3B4': '日本',
          'C3AD336E-C74D-D420-15DE-3C4C59AB82C1': 'All',
          'CD7D27B6-2D59-4C69-AB07-7CF52D07F377':
            '・メインで「誰でも、条件なしで運営管理手数料0円」を訴求してください。\n「0円」をいちばん強調してほしいです。\n\n・サブ訴求として、下記2つの訴求を入れてください。\n　・「「KAIZEN証券経済研究所」が選び抜いた厳選の25本をラインナップ」\n　・「証券口座と年金口座をまとめて管理」\n1シーンに1訴求の表示でお願いいたします。',
          'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA3': '無',
          'D7BEE39F-88BB-A696-B7DD-3447AE6B1FA4': '動画（mp4）',
          'D9FEAF78-87FF-40A0-9401-431C2C4472A0':
            '・「節税できる年金iDeCo」を訴求してください。\n「節税」と「iDeCo」を特に強調してほしいです。',
          'DB6767F4-C68C-7188-1D1C-6DF9BAFB3048': '日本語',
          'DCE45367-006F-43FA-BBD7-FEB0DBCFD05F':
            '資料請求に誘導して締めくくってください。\nシーン2でKAIZEN証券のポイントを理解したユーザーに対して、「資料請求して詳しく知りたい」と思わせるラストにしてください。',
          'E6810179-60AC-4BBD-A716-522CFEEC660F':
            '・KAIZEN証券のロゴを常設してください。\n・「0円訴求」のシーンでは必ず※の注釈も入れてください\n・トンマナ・フォントはバナーに準じてください。',
          'FFEFDFD0-B4FF-49E7-BAE5-771DE2C09FF5':
            '【前提】\nKaizen Ad発注者向けに、発注〜納品のサンプルを作成しております。本オファーは指示書記載・発注〜納品・修正の見本となります。\nそのため、架空の「KAIZEN証券」にて動画制作をお願いします。\n\n【サービス概要】\nKAIZEN証券のiDeCo（イデコ）個人型確定拠出年金は充実の運用商品ラインナップ！口座開設手数料・口座管理手数料も0円にてサービスをご提供！さあ、あなたもKAIZEN証券でiDeCoをはじめよう！',
        },
        bucketId: '4843a43f-23fc-4604-be18-b364328c1a0b',
        assetCategoryDefinition: {
          id: '1136',
          sections: [
            {
              id: '0a3dd0dd-611d-47c8-b38e-aad399fba0f3',
              meta: {
                helperUrl: 'https://help.kaizen-ad.com/ja/articles/4095148',
                isRequired: true,
                allowSearchTypes: [],
                allowRecommendTypes: [],
                audioPreparedMaterialIds: [],
                imagePreparedMaterialIds: [],
                videoPreparedMaterialIds: [],
                isAllowLeaveToTheCreators: false,
              },
              label: '',
              description:
                '■必要素材(最低1つのファイルをアップロードいただくか、URLの入力が必要です。複数選択可能)\n・LP/静止画バナー(ai/psdデータ推奨)\n・画像(png/jpg/bmp推奨)\n・動画(白素材データ+各音声データ推奨)\n・チラシ/パンフレットデータ(aiデータ推奨)\n・資料（パワーポイントなど）\n\n※ 以前制作した動画のリサイズをご発注の場合は下記データが必須素材となります\n・オリジナルの動画(mp4)\n\n※ 【オプション】ナレーションをご発注の場合は、下記データのご準備をお願いいたします\n・ナレーションをつける動画ファイル（mp4）\n・ナレーション原稿（Excel,word,pdfなど）\n・（必要がある場合のみ）BGM音源',
              fields: [
                {
                  key: '3ef3d9a7-062b-4f96-be6e-61adc7fc1b99',
                  type: 'FILE_IDS',
                  label: 'ファイルを選択',
                },
                {
                  key: 'bd1d10a5-0c68-42d2-bf3c-2ceed06e1787',
                  type: 'SINGLE_LINE_TEXT',
                  label: '共有ファイルのURL',
                  placeholder: 'https://',
                  helperText: '共有ファイルのURL',
                  isRequired: false,
                },
                {
                  key: '643df670-9be0-4bbf-b709-6c29e7900cea',
                  type: 'MULTI_LINE_TEXT',
                  label: '補足事項',
                  placeholder: '注意事項やパスワードなど',
                  helperText: '補足事項',
                  isRequired: false,
                },
                {
                  key: 'e907e43b-f263-4ef1-be99-d1f91524adda',
                  type: 'SELECT_ONE',
                  label: '素材を準備しますか？',
                  choices: [
                    {
                      key: 'leave to the creators',
                      label: 'クリエイターに任せる',
                    },
                    {
                      key: 'make your own choice',
                      label: '自分で選ぶ',
                    },
                  ],
                  helperText: '素材を準備しますか？',
                },
              ],
            },
          ],
        },
        assetCategoryValues: {
          '3ef3d9a7-062b-4f96-be6e-61adc7fc1b99': [
            '1be69730-aad9-4932-b1a6-a6371887744a',
            '671ab742-feb8-4d87-8f1f-56ad8e5496e2',
          ],
          '643df670-9be0-4bbf-b709-6c29e7900cea': '',
          'bd1d10a5-0c68-42d2-bf3c-2ceed06e1787': '',
          'e907e43b-f263-4ef1-be99-d1f91524adda': 'make your own choice',
        },
        creationSet: getDemoCreationSet('CS01FKQWW74B7X') as CreationSetForShowFragment,
        performanceReports: [],
        createdAt: '2021-11-05T11:13:54Z',
        submittedAt: '2019-06-12T06:14:44Z',
        adVideos: [],
        issue: null,
        progressSummary: {
          orderCount: 3,
          approvedCount: 3,
          modificationRequestCount: 0,
          modificationRequestFeedbackCount: 0,
        },
      },
    },
  },
];
